import React from 'react'
import ReportWrapper from '../ReportWrapper'
import BankApplicationRecordsOverview from './BankApplicationRecordsOverview'
import BankApplicationRecordsChart from './BankApplicationRecordsChart'
import InstitutionalApplicationRecords from './InstitutionalApplicationRecords'
import SpecialPeriodApplicationRecords from './SpecialPeriodApplicationRecords'
import ReportSectionHeading from '../ReportSectionHeading'
import { Table, TableData, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import { useViewMode } from '../ViewModeProvider'

interface BankApplicationRecordsProps {
  data: any
  title: string
  sectionIndex?: string
}

export default function BankApplicationRecords({ data, title, sectionIndex }: BankApplicationRecordsProps) {
  const theme = useTheme()
  const { viewMode } = useViewMode()

  const periods = [
    {
      label: '近7天',
      applyCount: data?.b_d7_apply_count ?? 0,
      orgCount: data?.b_d7_apply_org_count ?? 0,
    },
    {
      label: '近15天',
      applyCount: data?.b_d15_apply_count ?? 0,
      orgCount: data?.b_d15_apply_org_count ?? 0,
    },
    {
      label: '近1月',
      applyCount: data?.b_m1_apply_count ?? 0,
      orgCount: data?.b_m1_apply_org_count ?? 0,
    },
    {
      label: '近3月',
      applyCount: data?.b_m3_apply_count ?? 0,
      orgCount: data?.b_m3_apply_org_count ?? 0,
    },
    {
      label: '近6月',
      applyCount: data?.b_m6_apply_count ?? 0,
      orgCount: data?.b_m6_apply_org_count ?? 0,
    },
    {
      label: '近1年',
      applyCount: data?.b_m12_apply_count ?? 0,
      orgCount: data?.b_m12_apply_org_count ?? 0,
    },
  ]

  const tableData: TableData = {
    head: ['统计周期', '申请次数', '申请机构数'],
    body: periods.map((period) => [period.label, period.applyCount, period.orgCount]),
  }

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <BankApplicationRecordsOverview data={data} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          申请明细
        </Text>
        {viewMode === 'table' ? (
          <div className="mt-3">
            <Table
              data={tableData}
              highlightOnHover
              verticalSpacing="sm"
              styles={{
                table: {
                  fontSize: '13px',
                },
                th: {
                  backgroundColor: theme.surfaceMutedColor,
                  color: theme.accentTextColor,
                },
              }}
            />
          </div>
        ) : (
          <div className="mt-3">
            <BankApplicationRecordsChart data={data} />
          </div>
        )}
      </div>
      <InstitutionalApplicationRecords data={data} />
      <SpecialPeriodApplicationRecords data={data} />
    </ReportWrapper>
  )
}
